import http from "@/libs/http";
const school = {
  /**审批传统校 - 系统管理员、青少司 */
  schoolApprove: ApproveVO => {
    return http.post(http.formatUrl("school/approve"), ApproveVO);
  },
  /**批量审批传统校 - 系统管理员、青少司 */
  schoolApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("school/approve/batch"), BatchApproveVO);
  },
  /**删除传统校 - 系统管理员、项目中心*/
  schoolDelete: TraditionalSchoolId => {
    return http.post(http.formatUrl("school/delete"), TraditionalSchoolId);
  },
  /**查看传统校 - 系统管理员、项目中心、青少司*/
  schoolInfo: TraditionalSchoolId => {
    return http.get(http.formatUrl("school/info"), TraditionalSchoolId);
  },
  /**新建传统校 - 系统管理员、项目中心*/
  schoolInsert: TraditionalSchoolVO => {
    return http.post(http.formatUrl("school/insert"), TraditionalSchoolVO);
  },
  /**查询传统校分页列表 - 系统管理员 、项目中心 、青少司*/
  schoolPagelist: SchoolPageListVO => {
    return http.get(http.formatUrl("school/pagelist"), SchoolPageListVO);
  },
  /**撤销已提交的传统校 - 系统管理员、项目中心*/
  schoolRevoke: TraditionalSchoolId => {
    return http.post(http.formatUrl("school/revoke"), TraditionalSchoolId);
  },
  /**提交传统校 - 系统管理员、项目中心*/
  schoolSubmit: TraditionalSchoolId => {
    return http.post(http.formatUrl("school/submit"), TraditionalSchoolId);
  },
  /**批量提交传统校 - 系统管理员、项目中心*/
  schoolSubmitBatch: BatchTraditionalSchoolId => {
    return http.post(http.formatUrl("school/submit/batch"), BatchTraditionalSchoolId);
  },
  /**更新传统校 - 系统管理员、项目中心*/
  schoolUpdate: TraditionalSchoolVO => {
    return http.post(http.formatUrl("school/update"), TraditionalSchoolVO);
  }
};
export default school;
